import React from "react";
import "./termOfUse.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";

import { Container } from "react-bootstrap";
import { t } from "i18next";

export default function TermOfUse() {
  return (
    <div className="term-of-use ">
      <div className="d-flex justify-content-center">
        <HeaderBar title={t("term_of_use.title")} back={true} />
      </div>

      <Container>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Ultimo aggiornamento 2025-04-04
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>1. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Introduzione</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>Benvenuti su </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Volunteer</font>
            </font>
          </b>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              {" "}
              ("Team", "noi", "nostro", "ci")!
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              I presenti “Termini di servizio” (“Termini”) regolano l'utilizzo
              del nostro sito Web situato all'indirizzo{" "}
            </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                https://www.app-volunteer.com
              </font>
            </font>
          </b>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              {" "}
              (insieme o individualmente “Servizio”) gestito da{" "}
            </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Volunteer</font>
            </font>
          </b>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}> .</font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              La nostra “Informativa sulla privacy” regola anche l'utilizzo del
              nostro “Servizio” e spiega come raccogliamo, tuteliamo e
              divulghiamo le informazioni derivanti dall'utilizzo delle nostre
              pagine web.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Il tuo accordo con noi include questi “Termini” e la nostra
              “Informativa sulla Privacy” (“Accordi”). Riconosci di aver letto e
              compreso gli “Accordi” e accetti di esserne vincolato.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Se non sei d'accordo o se non puoi rispettare gli “Accordi” non
              puoi usare il “Servizio” offerto da Volunteer. Puoi tuttavia
              farcelo sapere inviando un'e-mail a
            </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                {" "}
                policy@app-volunteer.com
              </font>
            </font>
          </b>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              {" "}
              così potremo provare a trovare una soluzione. Questi Termini si
              applicano a tutti i visitatori, utenti e altri che desiderano
              visualizzare, navigare, accedere o usare il “Servizio” offerto da
              Volunteer.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>2. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Comunicazioni</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Utilizzando il nostro Servizio, accetti di iscriverti a
              newsletter, materiali di marketing o promozionali e altre
              informazioni che potremmo inviare. Tuttavia, puoi scegliere di non
              ricevere alcuna o tutte queste comunicazioni da parte nostra
              seguendo il link di annullamento dell'iscrizione o inviando
              un'e-mail a policy@app-volunteer.com
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>3. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Contenuto</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Il nostro “Servizio” ti consente di pubblicare, collegare,
              archiviare, condividere e altrimenti rendere disponibili
              determinate informazioni, testo, grafica, video o altro materiale
              (“Contenuto”). Sei responsabile del “Contenuto” che pubblichi su o
              tramite il “Servizio”, inclusa la sua legalità, affidabilità e
              appropriatezza.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Pubblicando “Contenuti” su o tramite il “Servizio”, dichiari e
              garantisci che (i) i “Contenuti” sono tuoi (ovvero che ne sei il
              proprietario) e che hai il diritto di utilizzarli e il diritto di
              concederci i diritti e la licenza come previsto nei presenti
              Termini, inoltre (ii) che la pubblicazione dei tuoi “Contenuti” su
              o tramite il “Servizio” non viola i diritti alla privacy, i
              diritti pubblicitari, i diritti d'autore, i diritti contrattuali o
              qualsiasi altro diritto di qualsiasi persona o entità. Ci
              riserviamo il diritto di chiudere l'account di chiunque venga
              scoperto a violare un copyright.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Mantieni tutti i tuoi diritti su qualsiasi “Contenuto” che invii,
              pubblichi o mostri su o tramite il “Servizio” e sei responsabile
              della protezione di tali diritti. Non ci assumiamo alcuna
              responsabilità per i “Contenuti” che tu o terze parti pubblicate
              su o tramite il “Servizio”. Tuttavia, pubblicando “Contenuti”
              tramite il “Servizio” ci concedi il diritto e la licenza di
              utilizzare, modificare, eseguire pubblicamente, mostrare
              pubblicamente, riprodurre e distribuire tali “Contenuti” su e
              tramite il “Servizio”. Accetti che questa licenza includa il
              diritto per noi di rendere i tuoi “Contenuti” disponibili ad altri
              utenti del “Servizio”, che possono anche utilizzare i tuoi
              “Contenuti” soggetti a questi “Termini”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Volunteer ha il diritto, ma non l’obbligo, di monitorare tutti i
              “Contenuti” forniti dagli utenti.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Inoltre, i “Contenuti” trovati su o tramite questo “Servizio” sono
              di proprietà di Volunteer o utilizzati con autorizzazione. Non
              puoi distribuire, modificare, trasmettere, riutilizzare,
              scaricare, ripubblicare, copiare o utilizzare tali “Contenuti”, in
              tutto o in parte, per scopi commerciali o per guadagno personale,
              senza l'espressa autorizzazione scritta anticipata da parte di
              Volunteer.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>4. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Usi proibiti</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Puoi utilizzare il “Servizio” solo per scopi leciti e in
              conformità con i “Termini”. Accetti di non utilizzare il
              “Servizio” offerto da Volunteer:
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              a) in qualsiasi modo che violi qualsiasi legge o regolamento
              nazionale o internazionale applicabile;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              b) allo scopo di sfruttare, danneggiare o tentare di sfruttare o
              danneggiare i minori in qualsiasi modo esponendoli a contenuti
              inappropriati o in altro modo;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              c) per trasmettere o procurare l'invio di qualsiasi materiale
              pubblicitario o promozionale, inclusa qualsiasi posta
              indesiderata, catena di Sant'Antonio, spam o qualsiasi altra
              sollecitazione simile;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              d) impersonare o tentare di impersonare il “Team” Volunteer, un
              membro del “Team” Volunteer, un altro utente o qualsiasi altra
              persona o entità;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              e) in qualsiasi modo che violi i diritti altrui, o in qualsiasi
              modo che sia illegale, minaccioso, fraudolento o dannoso, o in
              relazione a qualsiasi scopo o attività che sia illecita, illegale,
              fraudolenta o dannosa;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              f) per intraprendere qualsiasi altra condotta che limiti o
              inibisca l'uso o il godimento del “Servizio” da parte di chiunque,
              o che, come da noi determinato, possa danneggiare o offendere il
              “Team” o gli utenti del “Servizio” o esporli a responsabilità.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Inoltre, accetti di non:
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              a) utilizzare il “Servizio” in qualsiasi modo che possa
              disabilitare, sovraccaricare, danneggiare o compromettere il
              “Servizio” o interferire con l'utilizzo del “Servizio” da parte di
              terzi, inclusa la loro capacità di svolgere attività in tempo
              reale tramite il “Servizio”;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              b) utilizzare robot, spider o altri dispositivi, processi o mezzi
              automatici per accedere al Servizio per qualsiasi scopo, incluso
              il monitoraggio o la copia di qualsiasi materiale sul “Servizio”;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              c) utilizzare qualsiasi processo manuale per monitorare o copiare
              qualsiasi materiale sul “Servizio” o per qualsiasi altro scopo non
              autorizzato senza il nostro previo consenso scritto;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              d) utilizzare qualsiasi dispositivo, software o routine che
              interferisca con il corretto funzionamento del “Servizio”;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              e) introdurre virus, trojan horse, worm, bombe logiche o altro
              materiale dannoso o tecnologicamente dannoso;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              f) tentare di ottenere un accesso non autorizzato, interferire
              con, danneggiare o interrompere qualsiasi parte del “Servizio”, il
              server su cui è archiviato il “Servizio” o qualsiasi server,
              computer o database connesso al “Servizio”;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              g) lanciare un attacco al servizio tramite un attacco
              denial-of-service o un attacco denial-of-service distribuito;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              h) intraprendere qualsiasi azione che possa danneggiare o
              falsificare la valutazione di Volunteer;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              i) tentare di interferire con il corretto funzionamento del
              Servizio.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>5. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Analisi</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Potremmo avvalerci di “Fornitori” di servizi terzi per monitorare
              e analizzare l'utilizzo del nostro “Servizio”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>7. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Account</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Quando crei un account con noi, garantisci di avere più di
              diciotto (18) anni e che le informazioni che ci fornisci sono
              accurate, complete e aggiornate in ogni momento. Informazioni
              inaccurate, incomplete o obsolete possono comportare l'immediata
              cessazione del tuo account sul “Servizio”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Sei responsabile del mantenimento della riservatezza del tuo
              account e della tua password, inclusa ma non limitata alla
              restrizione dell'accesso al tuo computer e o account. Accetti di
              assumerti la responsabilità per tutte le attività o azioni che si
              verificano sotto il tuo account e o password, indipendentemente
              dal fatto che la tua password sia con il nostro “Servizio” o con
              un servizio di terze parti. Devi avvisarci immediatamente non
              appena vieni a conoscenza di qualsiasi violazione della sicurezza
              o uso non autorizzato del tuo account.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Non puoi usare come username il nome di un'altra persona o entità
              o che non sia legalmente disponibile per l'uso, un nome o un
              marchio che sia soggetto a qualsiasi diritto di un'altra persona o
              entità diversa da te, senza la dovuta autorizzazione. Non puoi
              usare come username alcun nome che sia offensivo, volgare o
              osceno.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Ci riserviamo il diritto di rifiutare il servizio, chiudere
              l’account, rimuovere o modificare i “Contenuti” o annullare ordini
              a nostra esclusiva discrezione.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>8. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Proprietà intellettuale
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Il servizio e il suo contenuto originale (esclusi i “Contenuti”
              forniti dagli utenti), le caratteristiche e le funzionalità sono e
              rimarranno di proprietà esclusiva di Volunteer e dei suoi
              licenziatari. Il servizio è protetto da copyright, marchi
              commerciali e altre leggi di e paesi stranieri. I nostri marchi
              commerciali non possono essere utilizzati in relazione a nessun
              prodotto o servizio senza il previo consenso scritto di Volunteer.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>10. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Politica sul copyright
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Rispettiamo i diritti di proprietà intellettuale altrui. È nostra
              politica rispondere a qualsiasi reclamo secondo cui i “Contenuti”
              pubblicati sul Servizio violano il copyright o altri diritti di
              proprietà intellettuale (“Violazione”) di qualsiasi persona o
              entità.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Se sei un titolare di copyright, o autorizzato per conto di uno, e
              ritieni che l'opera protetta da copyright sia stata copiata in un
              modo che costituisce una violazione del copyright, invia il tuo
              reclamo via e-mail a policy@app-volunteer.com, con l'oggetto
              Violazione del copyright e includi nel tuo reclamo una descrizione
              dettagliata della presunta violazione come dettagliato di seguito,
              in AVVISO DMCA E PROCEDURA PER RECLAMI DI VIOLAZIONE DEL
              COPYRIGHT.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Potresti essere ritenuto responsabile per i danni (inclusi costi e
              parcelle legali) per dichiarazioni false o reclami in malafede in
              merito alla violazione di qualsiasi “Contenuto” trovato sul
              “Servizio” e o tramite il “Servizio” in base al tuo copyright.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>10. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Avviso DMCA e procedura per reclami di violazione del copyright
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              È possibile inviare una notifica ai sensi del Digital Millennium
              Copyright Act (DMCA) fornendo al nostro agente per il copyright le
              seguenti informazioni per iscritto (vedere 17 USC 512(c)(3) per
              ulteriori dettagli):
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              a) una firma elettronica o fisica della persona autorizzata ad
              agire per conto del titolare del diritto d'autore;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              b) una descrizione dell'opera protetta da copyright che ritieni
              sia stata violata, incluso l'URL (ad esempio l'indirizzo della
              pagina web) del luogo in cui esiste l'opera protetta da copyright
              o una copia dell'opera protetta da copyright;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              c) identificazione dell'URL o di altra posizione specifica sul
              “Servizio” in cui si trova il materiale che si ritiene violi i
              diritti;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              d) il tuo indirizzo, numero di telefono e indirizzo email;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              e) una dichiarazione in cui attesti di ritenere in buona fede che
              l'uso contestato non è autorizzato dal titolare del copyright, dal
              suo agente o dalla legge;
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              f) una dichiarazione da parte tua, resa sotto pena di spergiuro,
              che le informazioni di cui sopra nella tua notifica sono accurate
              e che sei il titolare del copyright o sei autorizzato ad agire per
              conto del titolare del copyright.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Puoi contattare il nostro agente per il copyright via e-mail
              all'indirizzo policy@app-volunteer.com
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>11. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Segnalazione degli errori e feedback
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Puoi fornirci direttamente all'indirizzo policy@app-volunteer.com
              o tramite siti e strumenti di terze parti informazioni e feedback
              riguardanti errori, suggerimenti per miglioramenti, idee,
              problemi, reclami e altre questioni relative al nostro “Servizio”
              (“Feedback”). Riconosci e accetti che (i) non manterrai,
              acquisirai o affermerai alcun diritto di proprietà intellettuale o
              altro diritto, titolo o interesse nel o per il “Feedback”; (ii)
              Volunteer potrebbe avere idee di sviluppo simili al “Feedback”;
              (iii) il “Feedback” non contiene informazioni riservate o
              informazioni proprietarie da parte tua o di terze parti; e (iv)
              Volunteer non è tenuto ad alcun obbligo di riservatezza rispetto
              al “Feedback”. Nel caso in cui il trasferimento della proprietà
              del “Feedback” non sia possibile a causa di leggi obbligatorie
              applicabili, concedi a Volunteer e ai suoi affiliati un diritto
              esclusivo, trasferibile, irrevocabile, gratuito, sublicenziabile,
              illimitato e perpetuo di utilizzare (incluso copiare, modificare,
              creare lavori derivati, pubblicare, distribuire e
              commercializzare) il “Feedback” in qualsiasi modo e per qualsiasi
              scopo.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>12. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Collegamenti ad altri siti Web
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Il nostro “Servizio” potrebbe contenere link a siti web o servizi
              di terze parti che non sono di proprietà o controllati da
              Volunteer.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Volunteer non ha alcun controllo e non si assume alcuna
              responsabilità per il contenuto, le politiche sulla privacy o le
              pratiche di siti Web o servizi di terze parti. Non garantiamo le
              offerte di nessuna di queste entità/individui o dei loro siti Web.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              L'UTENTE RICONOSCE E ACCETTA CHE VOLUNTEER NON SARÀ RESPONSABILE,
              DIRETTAMENTE O INDIRETTAMENTE, PER QUALSIASI DANNO O PERDITA
              CAUSATO O PRESUNTAMENTE CAUSATO DA O IN RELAZIONE CON L'USO O
              L'AFFIDAMENTO SU TALI CONTENUTI, BENI O SERVIZI DISPONIBILI SU O
              ATTRAVERSO TALI SITI WEB O SERVIZI DI TERZE PARTI.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              TI CONSIGLIAMO VIVAMENTE DI LEGGERE I TERMINI DI SERVIZIO E LE
              POLITICHE SULLA PRIVACY DI QUALSIASI SITO WEB O SERVIZIO DI TERZE
              PARTI CHE VISITI.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>13. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Esclusione di garanzia
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              QUESTI SERVIZI SONO FORNITI DA VOLUNTEER COSÌ COME SONO E COME
              DISPONIBILI. VOLUNTEER NON RILASCIA ALCUNA DICHIARAZIONE O
              GARANZIA DI ALCUN TIPO, ESPRESSA O IMPLICITA, RIGUARDO AL
              FUNZIONAMENTO DEI PROPRI SERVIZI O ALLE INFORMAZIONI, AL CONTENUTO
              O AI MATERIALI IN ESSI INCLUSI. ACCETTI ESPRESSAMENTE CHE
              L'UTILIZZO DI QUESTI SERVIZI, DEL LORO CONTENUTO E DI QUALSIASI
              SERVIZIO O ARTICOLO OTTENUTO DA NOI È A TUO ESCLUSIVO RISCHIO.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              NÉ VOLUNTEER NÉ ALCUNA PERSONA ASSOCIATA A VOLUNTEER FORNISCE
              ALCUNA GARANZIA O DICHIARAZIONE RIGUARDO ALLA COMPLETEZZA,
              SICUREZZA, AFFIDABILITÀ, QUALITÀ, PRECISIONE O DISPONIBILITÀ DEI
              SERVIZI. SENZA LIMITARE QUANTO SOPRA, NÉ VOLUNTEER NÉ ALCUN
              SOGGETTO ASSOCIATO A VOLUNTEER DICHIARA O GARANTISCE CHE I
              SERVIZI, IL LORO CONTENUTO O QUALSIASI SERVIZIO O ELEMENTO
              OTTENUTO ATTRAVERSO I SERVIZI SARANNO ACCURATI, AFFIDABILI, ESENTI
              DA ERRORI O ININTERROTTI, CHE I DIFETTI SARANNO CORRETTI, CHE I
              SERVIZI O IL SERVER CHE LI RENDE DISPONIBILI SIANO ESENTI DA VIRUS
              O ALTRI COMPONENTI DANNOSI O CHE I SERVIZI O QUALSIASI SERVIZIO O
              ELEMENTO OTTENUTO ATTRAVERSO I SERVIZI SODDISFERANNO IN ALTRO MODO
              LE VOSTRE ESIGENZE O ASPETTATIVE.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              CON LA PRESENTE LA SOCIETÀ DECLINA OGNI GARANZIA DI ALCUN TIPO,
              SIA ESSA ESPRESSA O IMPLICITA, STATUTARIA O DI ALTRO TIPO,
              COMPRESE, A TITOLO ESEMPLIFICATIVO MA NON ESAUSTIVO, QUALSIASI
              GARANZIA DI COMMERCIABILITÀ, NON VIOLAZIONE E IDONEITÀ PER UNO
              SCOPO PARTICOLARE.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              QUANTO PRECEDENTE NON PREGIUDICA ALCUNA GARANZIA CHE NON POSSA
              ESSERE ESCLUSA O LIMITATA AI SENSI DELLA LEGGE APPLICABILE.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>14. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Limitazione di responsabilità
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              SALVO QUANTO VIETATO DALLA LEGGE, IL TEAM E VOLUNTEER SARANNO
              INDENNI PER QUALSIASI DANNO INDIRETTO, PUNITIVO, SPECIALE,
              ACCIDENTALE O CONSEGUENTE, COMUNQUE SI VERIFICHI (COMPRESI GLI
              ONORARI DEI LEGALI E TUTTI I COSTI E LE SPESE CORRELATI DI
              CONTENZIOSO E ARBITRATO, O IN PROCESSO O IN APPELLO, SE PRESENTI,
              INDIPENDENTEMENTE DAL FATTO CHE IL CONTENZIOSO O L'ARBITRATO
              VENGANO ISTITUITI), SIA IN UN'AZIONE DI CONTRATTO, NEGLIGENZA O
              ALTRO ATTO ILLECITO, O DERIVANTE DA O IN RELAZIONE AL PRESENTE
              CONTRATTO, COMPRESI SENZA LIMITAZIONE QUALSIASI RICHIESTA DI
              LESIONI PERSONALI O DANNI ALLA PROPRIETÀ, DERIVANTE DAL PRESENTE
              CONTRATTO E QUALSIASI VIOLAZIONE DA PARTE TUA DI QUALSIASI NORMA
              FEDERALE, STATALE O LEGGI, STATUTI, NORME O REGOLAMENTI LOCALI,
              ANCHE SE VOLUNTER È STATA PRECEDENTEMENTE INFORMATA DELLA
              POSSIBILITÀ DI TALE DANNO. SALVO QUANTO VIETATO DALLA LEGGE, SE VI
              È UNA RESPONSABILITÀ DA PARTE DI VOLUNTEER, QUESTA SARÀ LIMITATA
              ALL'IMPORTO PAGATO PER I PRODOTTI E O I SERVIZI E IN NESSUN CASO
              CI SARANNO DANNI CONSEGUENTI O PUNITIVI. ALCUNI STATI NON
              CONSENTONO L'ESCLUSIONE O LA LIMITAZIONE DI DANNI PUNITIVI,
              ACCIDENTALI O CONSEGUENTI, PERTANTO LA PRECEDENTE LIMITAZIONE O
              ESCLUSIONE POTREBBE NON ESSERE APPLICABILE A VOI.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>15. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Risoluzione</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Possiamo terminare o sospendere il tuo account e bloccare
              l'accesso al “Servizio” immediatamente, senza preavviso o
              responsabilità, a nostra esclusiva discrezione, per qualsiasi
              motivo e senza limitazioni, inclusa, a titolo esemplificativo ma
              non esaustivo, la violazione dei “Termini”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Se desideri chiudere il tuo account, puoi semplicemente
              interrompere l'utilizzo del “Servizio”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Tutte le disposizioni dei “Termini” che per loro natura dovrebbero
              sopravvivere alla risoluzione, sopravvivranno alla risoluzione,
              comprese, senza limitazioni, le disposizioni sulla proprietà, le
              esclusioni di garanzia, l'indennizzo e le limitazioni di
              responsabilità.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>16. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Legge applicabile
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              I presenti “Termini” saranno disciplinati e interpretati in
              conformità alle leggi italiane, la cui legge regolatrice si
              applicherà al contratto indipendentemente dalle disposizioni sui
              conflitti di legge.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              La nostra mancata applicazione di qualsiasi diritto o disposizione
              di questi “Termini” non sarà considerata una rinuncia a tali
              diritti. Se una qualsiasi disposizione di questi “Termini” è
              ritenuta non valida o non applicabile da un tribunale, le restanti
              disposizioni di questi “Termini” rimarranno in vigore. Questi
              “Termini” costituiscono l'intero accordo tra noi in merito al
              nostro “Servizio” e sostituiscono e sostituiscono qualsiasi
              accordo precedente che potremmo aver avuto tra noi in merito al
              “Servizio”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>17. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Modifiche al servizio
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Ci riserviamo il diritto di ritirare o modificare il nostro
              “Servizio” e qualsiasi servizio o materiale che forniamo tramite
              il “Servizio”, a nostra esclusiva discrezione e senza preavviso.
              Non saremo responsabili se per qualsiasi motivo tutto o parte del
              “Servizio” non fosse disponibile in qualsiasi momento o per
              qualsiasi periodo. Di tanto in tanto, potremmo limitare l'accesso
              ad alcune parti del “Servizio” o all'intero “Servizio” agli
              utenti, inclusi gli utenti registrati.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>18. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Modifiche ai termini
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Potremmo modificare i “Termini” in qualsiasi momento pubblicando i
              termini modificati su questo sito. È tua responsabilità rivedere
              periodicamente questi “Termini”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Il tuo uso continuato della Piattaforma dopo la pubblicazione dei
              “Termini” rivisti significa che accetti e acconsenti alle
              modifiche. Ti aspettiamo per controllare questa pagina
              frequentemente in modo da essere a conoscenza di eventuali
              modifiche, in quanto sono vincolanti per te.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Continuando ad accedere o utilizzare il nostro “Servizio” dopo che
              qualsiasi revisione è entrata in vigore, accetti di essere
              vincolato dai termini rivisti. Se non accetti i nuovi termini, non
              sei più autorizzato a utilizzare il “Servizio”.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>19. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Rinuncia e divisibilità
              </font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Nessuna rinuncia da parte di Volunteer a qualsiasi termine o
              condizione stabilito nei “Termini” sarà considerata una rinuncia
              ulteriore o continuativa a tale termine o condizione o una
              rinuncia a qualsiasi altro termine o condizione, e qualsiasi
              mancata rivendicazione da parte di Volunteer di un diritto o di
              una disposizione ai sensi dei “Termini” non costituirà una
              rinuncia a tale diritto o disposizione.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Se una qualsiasi disposizione dei “Termini” dovesse essere
              ritenuta non valida, illegale o inapplicabile per qualsiasi motivo
              da un tribunale o altro tribunale di giurisdizione competente,
              tale disposizione sarà eliminata o limitata nella misura minima
              necessaria affinché le restanti disposizioni dei “Termini”
              continuino ad avere pieno vigore ed efficacia.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>20. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Riconoscimento</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              UTILIZZANDO IL SERVIZIO O ALTRI SERVIZI DA NOI FORNITI, RICONOSCI
              DI AVER LETTO I PRESENTI TERMINI DI SERVIZIO E ACCETTI DI ESSERE
              VINCOLATO DA ESSI.
            </font>
          </font>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>21. </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Contattaci</font>
            </font>
          </b>
        </p>
        <p>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              Inviate i vostri feedback, commenti e richieste di supporto
              tecnico via email{" "}
            </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                policy@app-volunteer.com
              </font>
            </font>
          </b>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}> .</font>
          </font>
        </p>
        <p style={{ marginTop: "5em", fontSize: "0.7em" }}>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>Le presenti</font>
          </font>
          <a href="https://policymaker.io/terms-and-conditions/">
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Condizioni di servizio
              </font>
            </font>
          </a>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}>
              sono state create per{" "}
            </font>
          </font>
          <b>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                https://app-volunteer.com
              </font>
            </font>
          </b>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}> da</font>
          </font>
          <a href="https://policymaker.io">
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>PolicyMaker.io</font>
            </font>
          </a>
          <font style={{ verticalAlign: "inherit" }}>
            <font style={{ verticalAlign: "inherit" }}> il 04/04/2025.</font>
          </font>
        </p>
      </Container>
    </div>
  );
}
